import { render, staticRenderFns } from "./AwbTracking.vue?vue&type=template&id=5b3084ab&"
import script from "./AwbTracking.vue?vue&type=script&lang=js&"
export * from "./AwbTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports